import { render, staticRenderFns } from "./Div_evaluacion.vue?vue&type=template&id=5ae847f8"
import script from "./Div_evaluacion.vue?vue&type=script&lang=js"
export * from "./Div_evaluacion.vue?vue&type=script&lang=js"
import style0 from "./Div_evaluacion.vue?vue&type=style&index=0&id=5ae847f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports